export default __webpack_public_path__ + "static/media/dentaverse1.7f448f5d.PNG";